import styled from "styled-components";
import colours from "styles/colours";
import { fontWeights } from "styles/fonts";

export const IrisPageFrame = styled.div`
  box-shadow: inset 1px 0 0 ${colours.elexonBlue};
  padding-left: 8px;
  margin-top: 3rem;
`;

export const IrisBlueDivider = styled.hr`
  border: 0;
  border-top: 1px solid ${colours.elexonBlue};
  margin: 24px 0;
`;

export const GreyContainer = styled.div`
  background-color: ${colours.backgroundGrey};
  padding-bottom: 0.1em;
`;

export const Header = styled.h2`
  color: ${colours.elexonBlack};
  padding-top: 0.75em;
  background-color: transparent;

  && {
    margin-bottom: 2em;
    font-size: 2em;
    font-weight: ${fontWeights.heavy};
  }
`;
